import React from 'react';
import { Button, useMediaQuery } from "@mui/material";
import Logo from "../../Assests/Images/MainLogo.png";
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function Header() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState("");
  const Navigate = useNavigate()
  
  useEffect(() => {
    setCurrentTab(location.pathname.split("/")[1]);
  }, [location]);

  return (
    <nav style={{ 
      display: "flex", 
      padding: isSmallScreen ? "1rem 1rem" : "2rem 4rem", 
      alignItems: "center", 
      justifyContent: "space-between",
      // flexDirection: isSmallScreen ? "column" : "row",
      textAlign: "center",
    }}>
      <div style={{cursor:"pointer"}}>
        <img alt="logo" src={Logo} width={isSmallScreen ? "40px" : "60px"} onClick={()=>Navigate("/")}/>
      </div>
      {currentTab === "" && <div style={{display: "flex", 
      alignItems: "center", 
      justifyContent: "center",}}>
        <Button 
          variant="outlined" 
          size="small" 
          sx={{
            borderRadius: "60px",
            border: "2px solid #6E07F3",
            color: "#6E07F3",
            fontSize: isSmallScreen ?"14px":"18px",
            padding: isSmallScreen ? "6px 20px" : "8px 25px",
            "&:hover": {
              backgroundColor: "#6E07F3",
              color: "white",
              border: "2px solid #6E07F3",
            },
            textTransform: "none",
            fontFamily: "Font2"
          }}
          onClick={()=>Navigate("/contact")}
        >
          Say Hello
        </Button>
      </div>}
    </nav>
  );
}

export default Header;
